var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Checkbox',{ref:"form",attrs:{"label-size":"large","value":_vm.value,"title":_vm.description},on:{"input":_vm.onChange}},[_c('span',{attrs:{"title":_vm.label}},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }